import { Action, createReducer, on } from '@ngrx/store';
import { SalesRepresentativeStore } from '../../models/store/user/sales';

import {
  loadSalesRepresentatives,
  paginateSalesRepresentatives,
  removeAllSalesRepresentatives,
  removeSalesRepresentatives
} from 'src/actions/user/sales.action';

export const initialState: SalesRepresentativeStore = {
  fetching: false,
  data: {
    salesRepresentatives: [],
    totalDocuments: 0
  }
};

const salesrepresentativesReducer = createReducer(initialState,
  on(loadSalesRepresentatives, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        salesRepresentatives: [
          ...state.data.salesRepresentatives,
          ...payload.filter(p => !state.data.salesRepresentatives.find(ds => ds._id === p._id))
        ],
        totalDocuments
      }
    })
  ),
  on(removeSalesRepresentatives, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        salesRepresentatives: state.data.salesRepresentatives
          .filter(d => !payload.includes(String(d._id))),
        totalDocuments: state.data.totalDocuments - 1,
      }
    })
  ),
  on(removeAllSalesRepresentatives, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        salesRepresentatives: [],
        totalDocuments: 0
      }
    }
  )
  ),
  on(paginateSalesRepresentatives, (state) => state)
);

export function reducer(state: SalesRepresentativeStore, action: Action) {
  return salesrepresentativesReducer(state, action);
}
